import DistributaryZoneList from "../components/configuration/DistributaryZone/DistributoryZoneList";

const DistributaryZoneListPage = () => {
    return (
        <DistributaryZoneList />
    );
};  

export default DistributaryZoneListPage;
